import SeoHead from '../../components/SeoHead';
import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
// import { Collection } from "@sourceflow-uk/sourceflow-sdk"
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import SimplePage from '../../components/SimplePage';
import AllLocations from '../../components/AllLocations';
import Header from '../../components/MainHeader';
import MailchimpWidget from '../../components/MailchimpWidget';

export default function EmployersGetInTouch({
    global,
    all_locations,
    all_region_locations
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Employers - Get in touch | Gap Personnel`}
                // description={`Get in touch with Driving Force to discuss your driving job requirements by phone on 0845 634 1161 or email: marketing@driving-force.co.uk`}
                canonical_link={`/employers-get-in-touch/`}
            />
            <Header />
            <SubBanner
                global={global}
                pathPrefix={`employers_get_in_touch_page.sub_banner`}
                customClass={`mb-5 primary-banner get-in-touch`}
                buttonTitle={`Employers`}
                buttonLink={`/who-we-are/`}
                heading={`Get in touch`}
                bannerImage="/site-assets/images/employer-contact.jpg"
                bannerImageAlt="Employer Get in touch"

            />
            <SimplePage
                global={global}
                pathPrefix={`employers_get_in_touch_page.simple_page_1`}
                customClass={``}
                content={
                    <>
                        <h5>Our branches offer regional coverage.</h5>
                        <p>Get in touch with the team who are most local to you; either give them a call or drop your message in the get in touch form.</p>
                    </>
                }
                textCenter={true}
            />
            <AllLocations
                global={global}
                pathPrefix={`employers_get_in_touch_page.all_locations`}
                all_locations={all_locations}
                all_region_locations={all_region_locations}
                customClass={`mt-5`}
            />
            <MailchimpWidget />
            {/* <SimplePage
                global={global}
                pathPrefix={`employers_get_in_touch_page.simple_page_2`}
                customClass={``}
                content={``}
                formId={`2b1903d0-c09a-4b34-9c3b-27a7b7afb573`}
                heading={`Get in touch`}
                textCenter={true}
            /> */}
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const locations = await Collection('locations');
    // Pulls parent region only.
    const all_region_locations = locations.orderBy('order')
        .getItems().filter(sector =>
            (sector.parent.identifier === null));
    // Pulls children region only.
    const all_locations = locations.orderBy('order')
        // .getItems().filter(sector =>
        //     (sector.parent.identifier != null));
        .getItems();

    return {
        props: {
            global,
            all_locations,
            all_region_locations
        },
    }
}